import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CardDetails } from '../models/order';
import { OrderService } from '../order.service';

export class PaymentOption{
  cash:boolean;
  card:boolean;
  storeCredit:boolean;
  cardDetail:CardDetails;
  storeCreditBalance:number;

  constructor(cash:boolean, card:boolean, storeCredit:boolean,
      cardDetail:CardDetails, storeCreditBalance:number=0){
    this.cash=cash;
    this.card=card;
    this.storeCredit=storeCredit;
    this.cardDetail=cardDetail;
    this.storeCreditBalance=storeCreditBalance;
  }

  hasPaymentOption(){
    return this.cash || this.card || this.storeCredit || (this.storeCredit && this.cash) || (this.storeCredit && this.card)
  }
}

@Injectable()
export class PaymentOptionService{
  private source = new BehaviorSubject<PaymentOption>(null);
  current = this.source.asObservable();

  constructor(){}

  updatePaymentOption(paymentOption: PaymentOption) {
    if(paymentOption){
      this.source.next(paymentOption);
    }

  }
}
